/* global axios */
import ApiClient from './ApiClient';

class BulkActionsAPI extends ApiClient {
  constructor() {
    super('bulk_actions', { accountScoped: true });
  }

  create(params) {
    return axios.post(this.url, params);
  }
}

export default new BulkActionsAPI();
